/**
 * Product Inventory JS
 * Handles inventory status displays
 */

document.addEventListener('DOMContentLoaded', function() {
  initProductInventory();
  
  // Listen for variant change events from product-form
  document.addEventListener('variant:changed', handleVariantChanged);
});

function initProductInventory() {
  // Initialize all inventory elements on the page
  const inventoryElements = document.querySelectorAll('.product-inventory');
  inventoryElements.forEach(element => {
    // Store original templates from the server-rendered HTML
    element.originalContent = element.innerHTML;
    element.outTemplate = element.querySelector('.inventory--out')?.outerHTML;
    element.lowTemplate = element.querySelector('.inventory--low')?.outerHTML;
    element.inStockTemplate = element.querySelector('.inventory--hidden')?.outerHTML;
    element.lowStockThreshold = parseInt(element.dataset.lowStock) || 10;
  });
}

function handleVariantChanged(event) {
  if (!event.detail || !event.detail.variant) return;
  
  // Find the closest inventory element
  const inventoryElement = event.target.closest('.product-form')?.querySelector('.product-inventory');
  if (!inventoryElement) return;
  
  updateInventory(inventoryElement, event.detail.variant);
}

function updateInventory(element, variant) {
  if (!variant || !variant.inventory_management) {
    // Show in-stock state
    if (element.inStockTemplate) {
      element.innerHTML = element.inStockTemplate;
    }
    element.classList.add('inventory--hidden');
    element.classList.remove('inventory--low', 'inventory--out');
    return;
  }
  
  const quantity = variant.inventory_quantity;
  
  if (quantity <= 0 && !variant.available) {
    // Out of stock
    if (element.outTemplate) {
      element.innerHTML = element.outTemplate;
    } else {
      element.innerHTML = element.originalContent;
      element.classList.add('inventory--out');
    }
    element.classList.add('inventory--out');
    element.classList.remove('inventory--low', 'inventory--hidden');
  } 
  else if (quantity <= element.lowStockThreshold && quantity > 0) {
    // Low stock - replace count in the existing template
    if (element.lowTemplate) {
      const template = element.lowTemplate.replace(/\d+(?=\s+left)/, quantity);
      element.innerHTML = template;
    }
    element.classList.add('inventory--low');
    element.classList.remove('inventory--out', 'inventory--hidden');
  }
  else {
    // Plenty of stock
    if (element.inStockTemplate) {
      element.innerHTML = element.inStockTemplate;
    }
    element.classList.add('inventory--hidden');
    element.classList.remove('inventory--low', 'inventory--out');
  }
} 